import React from 'react';
import { Link } from 'react-router-dom';

const FOOTER_LINKS_FALLBACK = [
  { id: 1, label: 'Home', url: '/' },
  { id: 2, label: 'Our Technology', url: '/our-technology' },
  { id: 3, label: 'For Farmers', url: '/for-farmers' },
  { id: 4, label: 'For Buyers', url: '/for-buyers' },
  { id: 5, label: 'Our Journey', url: '/our-journey' },
  { id: 6, label: 'Contact', url: '/contact' },
];

const Footer = ({ global }) => {
  const links = global?.footer_links || FOOTER_LINKS_FALLBACK;
  const tagline = global?.footer_tagline || 'Empowering farmers, enabling buyers, revolutionizing the agricultural supply chain';

  return (
    <footer className="bg-black text-white pt-28 pb-32">
      <div className="container mx-auto px-6 text-center max-w-[1100px]">
        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-4 md:gap-x-10 mb-8">
          {links.map((link) => (
            <Link
              key={link.id}
              to={link.url}
              className="text-[22px] md:text-[28px] font-bold text-white hover:text-widya-green transition-colors duration-200 tracking-[-0.5px]"
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Tagline */}
        <p className="text-[#cccccc] text-[16px] md:text-[18px] mb-12 max-w-3xl mx-auto tracking-[-0.2px]">
          {tagline}
        </p>

        {/* Green Line */}
        <div className="w-[100px] h-[3px] bg-[#67ba8e] mx-auto rounded-full" />
      </div>
    </footer>
  );
};

export default Footer;